/* eslint-disable no-loop-func */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import { useContext } from "react";
import { Link, useHistory } from "react-router-dom";

import logo from "../../assets/images/logo.png";
import Card from "../../components/Card";
import InfiniteScroll from "react-infinite-scroll-component";
import { CartContext } from "../../CartContext";
import PageLoading from "../../components/PageLoading";
import { getCookie } from "../../common/functions";
import ProductSkeleton from "../../components/PageLoading/ProductSkeleton";

import { toast } from "mdbreact";
import {
  getParamValues,
  getImagePath,
  toFixed,
  getDefValues,
  getCurrency,
  getLoginInfo,
  getLanguage,
  callApiV2,
  buildProductsCard,
} from "../../common/functions";

import defaultImage from "../../assets/images/default.jpg";
import Modal from "../../components/ModalV2";

const maxItemsFilter = getParamValues().maxItemsFilter;
const loginMenuoptions = getParamValues().loginMenuoptions;
const eventMenuoptions = getParamValues().eventMenuoptions;

const loggedMenuoptions = getParamValues().loggedMenuoptions;
const shippingMenuoptions = getParamValues().shippingMenuoptions;
const mobileMenuoptions = getParamValues().mobileMenuoptions;
/*
const initialSearchData = {
  searchinput: "",
  results: [],
  showtype: "grid",
  showresults: false,
  categories: [],
  showcategories: false,
  listcategories: true,
  selectedcategories: [],
  options: [],
  minprice: 0,
  maxprice: 0,
  minpricedef: 0,
  maxpricedef: 0,
  listprices: true,
  reloadpage: false,
};
*/
const initialCardConfig = {
  pagesettings: {
    itemsperpage: 15,
    currentPage: 1,
  },
};

//var hide=false;

var timeout = null;
const Header = (props) => {
  const history = useHistory();
  const { shopCart } = useContext(CartContext);

  const { eventQty } = useContext(CartContext);

  const [loading, setloading] = useState("NO");
  const [showForm, setShowForm] = React.useState(false);
  const [tempStore, setTempStore] = React.useState(0);
  const [totalRows, setTotalRows] = React.useState(null);
  const [size, setSize] = React.useState(0);
  const [hasMore, setHasMore] = React.useState(false);
  const [cardData, setCardData] = React.useState([]);
  const [cardConfig, setCardConfig] = React.useState(initialCardConfig);
  //const [storesInfo, setStoresInfo] = React.useState([]);
  const [fromH, setFromH] = React.useState(1);
  //const [isLoadingP, setIsLoadingP] = React.useState(false);
  //const [productNotFounded, setProductNotFounded] = React.useState(true);
  const [storeid, setStoreId] = React.useState("0");
  const [searchinput, setSearchinput] = React.useState("");
  const [storeMenuOpen, setStoreMenuOpen] = React.useState(false);

  React.useEffect(() => {
    if (!storeMenuOpen) return;
    const close = () => setStoreMenuOpen(false);
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [storeMenuOpen]);
  const [eventActionM, setEventActionM] = useState("");
  const [loginInfo, setLoginInfo] = React.useState({ userId: null });

  //const [searchData, setSearchData] = React.useState(initialSearchData);
  React.useEffect(() => {
    let _loginInfo = getLoginInfo();
    setLoginInfo(_loginInfo);
    let eventActionM = getCookie(process.env.REACT_APP_ORG_NAME + "_action");
    setEventActionM(eventActionM);
    let _storeid = props.storesInfo.selectedCatalogId;
    setStoreId(_storeid);
    //setStoresInfo(props.storesInfo);
  }, [props]);

  const checkEventStatus = (subitem) => {
    var eventId = getCookie(process.env.REACT_APP_ORG_NAME + "_eventId");
    var eventAction = getCookie(process.env.REACT_APP_ORG_NAME + "_action");
    //console.log(subitem,eventId, eventAction, subitem.link )

    if (parseInt(eventId) > 0) {
      if (
        eventAction === "addEventList" &&
        subitem.link.indexOf("/customer/event/manage") >= 0
      ) {
        //console.log("push")
        //history.push(subitem.link );
      } else if (
        eventAction === "addEventCart" &&
        subitem.link === "/customer/event/event-details"
      ) {
        history.push(subitem.link);
      } else {
        toggleModal(subitem);
      }
    } else {
      history.push(subitem.link);
    }
  };

  const changeHandlerS = (event) => {
    if (event.target.value !== searchinput) {
      setSearchinput(event.target.value);
      if (event.target.value.length < 3) {
        //setSearchData(initialSearchData);
      } else {
        clearTimeout(timeout);
        timeout = setTimeout(async function () {
          clearData();
          console.log("buscando...");
          await getProducts(fromH, false, event.target.value);
        }, 350);
      }
    }
  };

  const fetchMoreData = async () => {
    //console.log("fetchMoreData", cardData.length, totalRows);
    await getProducts(fromH, true, searchinput);
  };
  const getProducts = async (page, isAdding, searchinput) => {
    try {
      //console.log("getProducts", hasMore, page, cardData.length);
      //setIsLoadingP(true);
      let itemsperpage = cardConfig.pagesettings.itemsperpage;
      if (props.windowWidth < 799) {
        itemsperpage = 10;
      } else {
        itemsperpage = 6;
      }
      let _from = (page - 1) * itemsperpage;
      //console.log("fromH", _from);
      var data = {
        languageid: getLanguage(),
        searchkey: searchinput,
        storeid: storeid,
        size: itemsperpage,
        fromH: _from,
      };
      var resp = await callApiV2("customer", "getFilterProducts", data);

      //console.log("total", resp.meta.total);
      if (resp.rows.length <= 0) {
        //setIsLoadingP(false);
        //setProductNotFounded(true);
        setHasMore(false);
      } else {
        //console.log("resp", resp);
        let prodDefConfig = {
          pagewidth: "col-md-12 col-lg-12 col-xl-12",
          colsize: "col-6",
          colsizelg: "col-lg-4",
          colsizemd: "col-md-6",
          colsizesm: "col-sm-6",
          limit: 1000,
        };
        let respCat = await buildProductsCard(
          resp,
          cardConfig.pagesettings,
          null, //ANTES this.managepagination,
          null, //ANTES this.manageCart,
          prodDefConfig,
          "categories",
          null, //categoryRouteObj,
          null, //categoryid,
          toast,
        );

        let _cardConfig = respCat.cardConfig;
        delete _cardConfig["managepagination"];
        //delete cardConfig["pagesettings"];
        _cardConfig["mobile"] = true;

        //console.log("respCat", respCat);

        if (isAdding) {
          setCardData([...cardData, ...respCat.cardProducts]);
        } else {
          setCardData(respCat.cardProducts);
        }
        if (size < resp.meta.total && resp.meta.total > 10) {
          setHasMore(true);
        } else {
          setHasMore(false);
        }
        setCardConfig(_cardConfig);
        setTotalRows(resp.meta.total);
        setSize(size + resp.rows.length);
        setFromH(fromH + 1);
        //setIsLoadingP(false);
      }
    } catch (Excep) {
      console.log(">>>>>>>", Excep);
    } finally {
      //setIsLoadingP(false);
    }
  };
  /*
  const _manageCart = async (event) => {
    try {
      setloading("YES");
      props.forceHideCart();
      var resp = await manageCart(event, cardData, _manageCart, toast);
      //console.log(resp)
      if (resp.success) {
        if (!resp.redirect) {
          cardData = resp._cardData;

          //console.log("UPDATE")
          //console.log("!!!",resp._cardData)

          if (resp.dataCart) {
            //console.log("dataCart")
            cardData = resp._cardData;
            props.updateCart(resp.dataCart);
          }
        } else {
          redirectTo(resp.selectedCategory + "/" + resp.selectedPath);
          //	window.location.reload();
        }
      } else {
        //console.log(">>>>>>>",resp.message)
      }
      setloading("NO!");
    } catch (Excep) {
      console.log(">>>>>>>", Excep);
    }
  };
  */
  const redirectTo = (pathValue) => {
    props.closePopUpSearcher();
    history.push("/" + pathValue);
  };
  /*
  const getSearchResults = async (searchkey, page, size) => {
    let data = {
      searchkey: searchkey,
      page: page,
      storeid: storeid,
      size: size,
    };
    //setSearchKey(searchkey);
    if (searchkey.length > 3) {
      //setLoadingSearchResults(true);
      callApi("customer", "getFilterProductsElastic", data).then((res) => {
        if (res.errorcode === "0") {
          //setSearchResults(res.rows);
          //setLoadingSearchResults(false);
        }
        //console.log(res)
      });
    } else {
      //setSearchResults([]);
      //setLoadingSearchResults(false);
    }
  };
  */
  const navigateTo = (searchValue) => {
    console.log("navigate");
    history.push("/search?key=" + searchValue);
    props.hideFilter();
    props.changeHandlerS({
      target: { value: searchValue, name: "key" },
    });
  };

  const clearData = () => {
    setCardData([]);
    setCardConfig(initialCardConfig);
    //setSearchinput("");
    setTotalRows(null);
    setHasMore(false);
    setFromH(1);
    setSize(0);
  };

  var menu = [];

  if (props.menuTemplate) {
    menu = props.menuTemplate;
  }

  var totalProd = 0;
  if (shopCart?.products) {
    shopCart.products.map(function (key) {
      totalProd = totalProd + key.quantity;
    });
  }

  const toggleModal = (event) => {
    //console.log("toggleModal", tempStore)
    setShowForm(!showForm);
  };

  const setEventMode = async (event) => {
    history.push("/");
    await props.setEventMode(null, null, null, null, tempStore);
  };

  return props.action === "" && props.showSearcher ? (
    <>
      <div className="searcher-mobile" style={{ position: "absolute" }}>
        <div className="row row-top">
          <div className="col-9">
            <input
              type="text"
              name="key"
              ref={(input) =>
                input && props.mobileFirstTime ? input.focus() : ""
              }
              value={searchinput}
              onChange={changeHandlerS}
              onKeyDown={changeHandlerS}
              className="search-mobile"
              placeholder={getDefValues().searchLabel}
            />
          </div>
          <div className="col-3 flex middle items-right text-right">
            <button
              type="button"
              className="searcher-mobile-button"
              onClick={() => {
                console.log("closing");
                clearData();
                setSearchinput("");
                props.toggleSearcher();
              }}
            >
              {getDefValues().closeLabel.toUpperCase()}
            </button>
          </div>
        </div>
        {totalRows && (
          <div className="row options">
            <div className="col-9">
              {getDefValues().resultsLabel.toUpperCase() + ": " + totalRows}
            </div>
            <div className="col-3 flex middle  items-right text-right">
              <button
                type="button"
                className="searcher-mobile-button"
                onClick={
                  props.searchData.results.length > 0 ??
                  props.toggleMobileFilters
                }
              >
                {getDefValues().filterLabel.toUpperCase()}
              </button>
            </div>
          </div>
        )}
        <div
          className={
            props.showMobileFilters
              ? "mobile-showFilters filter-background visible"
              : "mobile-showFilters"
          }
        >
          <div className="col-12 mobile-col-cat">
            <div className="col-cat-content">
              {props.searchData.categories.length > 0 ? (
                <>
                  <ul className="categories">
                    <li className="">
                      <button
                        name="toggle_listcategories"
                        onClick={props.manageSearch}
                        className="btn btn-sm title-name searcher-mobile-button"
                      >
                        {getDefValues().categoryLabel}
                        {props.searchData.selectedcategories.length > 0
                          ? " (" +
                            props.searchData.selectedcategories.length +
                            ")"
                          : ""}
                      </button>

                      <button
                        name="toggle_listcategories"
                        onClick={props.manageSearch}
                        className="btn btn-sm title-button searcher-mobile-button"
                      >
                        <i
                          className={
                            "fas " +
                            (props.searchData.listcategories
                              ? "fa-minus"
                              : "fa-plus")
                          }
                        />
                      </button>
                    </li>
                  </ul>
                  {props.searchData.listcategories ? (
                    <>
                      <ul className="categories">
                        {props.searchData.categories.map((item, i) =>
                          props.searchData.showcategories ||
                          i < maxItemsFilter ? (
                            <li
                              key={"li1" + i}
                              className={
                                props.searchData.selectedcategories.indexOf(
                                  "" + item.categoryid,
                                ) >= 0
                                  ? "active"
                                  : ""
                              }
                            >
                              <button
                                key={"button5" + i}
                                name={"filter_categories_" + item.categoryid}
                                onClick={props.manageSearch}
                                className="btn btn-sm name searcher-mobile-button "
                              >
                                {item.categoryname}
                              </button>
                              <button
                                key={"button6" + i}
                                name={"filter_categories_" + item.categoryid}
                                onClick={props.manageSearch}
                                className="btn btn-sm quantity searcher-mobile-button"
                              >
                                {item.quantity}
                              </button>
                            </li>
                          ) : (
                            ""
                          ),
                        )}
                      </ul>
                      {!props.searchData.showcategories &&
                      props.searchData.categories.length > maxItemsFilter ? (
                        <div className="flex items-center">
                          <button
                            name="show_showcategories"
                            onClick={props.manageSearch}
                            className="btn btn-sm searcher-mobile-button"
                          >
                            {getDefValues().showMoreLabel}
                          </button>
                        </div>
                      ) : (
                        ""
                      )}
                      {props.searchData.showcategories &&
                      props.searchData.categories.length > maxItemsFilter ? (
                        <div className="flex items-center">
                          <button
                            name="hide_showcategories"
                            onClick={() => {
                              setCardData([]);
                              setCardConfig(initialCardConfig);
                              props.manageSearch({
                                target: { name: "hide_showcategories" },
                              });
                            }}
                            className="btn btn-sm searcher-mobile-button"
                          >
                            {getDefValues().hideLabel}
                          </button>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  {props.searchData.selectedcategories.length > 0 &&
                  !props.searchData.listcategories ? (
                    <>
                      <ul className="categories ml-1 mr-2">
                        {props.searchData.categories.map((item, i) =>
                          props.searchData.selectedcategories.indexOf(
                            "" + item.categoryid,
                          ) >= 0 ? (
                            <li key={"li2" + i} className="active">
                              <button
                                key={"button3" + i}
                                name={"filter_categories_" + item.categoryid}
                                onClick={props.manageSearch}
                                className="btn btn-sm name searcher-mobile-button "
                              >
                                {item.categoryname}
                              </button>
                              <button
                                key={"button4" + i}
                                name={"filter_categories_" + item.categoryid}
                                onClick={props.manageSearch}
                                className="btn btn-sm quantity searcher-mobile-button"
                              >
                                {item.quantity}
                              </button>
                            </li>
                          ) : (
                            ""
                          ),
                        )}
                      </ul>
                    </>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}
              {props.searchData.options.length > 0
                ? props.searchData.options.map((item, i) => (
                    <div key={"div1" + i} className="mt-2 mb-2">
                      <ul key={"ul1" + i} className="categories">
                        <li key={"li2" + i} className="">
                          <button
                            key={"button2" + i}
                            name={"toggle_listoptions_" + item.optionid}
                            onClick={props.manageSearch}
                            className="btn btn-sm title-name searcher-mobile-button"
                          >
                            {item.optionname}
                            {item.selectedoptions.length > 0
                              ? " (" + item.selectedoptions.length + ")"
                              : ""}
                          </button>

                          <button
                            key={"button2b" + i}
                            name={"toggle_listoptions_" + item.optionid}
                            onClick={props.manageSearch}
                            className="btn btn-sm title-button searcher-mobile-button"
                          >
                            <i
                              key={"i1" + i}
                              className={
                                "fas " +
                                (item.listoptions ? "fa-minus" : "fa-plus")
                              }
                            />
                          </button>
                        </li>
                      </ul>

                      {item.listoptions ? (
                        <>
                          <ul key={"ul2a" + i} className="categories">
                            {item.options.map((option, i) =>
                              item.showoptions || i < maxItemsFilter ? (
                                <li
                                  key={"li2a" + i}
                                  className={
                                    item.selectedoptions.indexOf(
                                      "" + option.value,
                                    ) >= 0
                                      ? "active"
                                      : ""
                                  }
                                >
                                  <button
                                    key={"button3b" + i}
                                    name={
                                      "filter_options_" +
                                      item.optionid +
                                      "_" +
                                      option.value
                                    }
                                    onClick={props.manageSearch}
                                    className="btn btn-sm name searcher-mobile-button "
                                  >
                                    {option.value}
                                  </button>
                                  <button
                                    key={"button4b" + i}
                                    name={
                                      "filter_options_" +
                                      item.optionid +
                                      "_" +
                                      option.value
                                    }
                                    onClick={props.manageSearch}
                                    className="btn btn-sm quantity searcher-mobile-button"
                                  >
                                    {option.quantity}
                                  </button>
                                </li>
                              ) : (
                                ""
                              ),
                            )}
                          </ul>
                          {!item.showoptions &&
                          item.options.length > maxItemsFilter ? (
                            <div
                              key={"div2a" + i}
                              className="flex items-center"
                            >
                              <button
                                key={"button5b" + i}
                                name={"show_showoptions_" + item.optionid}
                                onClick={props.manageSearch}
                                className="btn btn-sm searcher-mobile-button"
                              >
                                {getDefValues().showMoreLabel}
                              </button>
                            </div>
                          ) : (
                            ""
                          )}
                          {item.showoptions &&
                          item.options.length > maxItemsFilter ? (
                            <div
                              key={"div3a" + i}
                              className="flex items-center"
                            >
                              <button
                                key={"button5c" + i}
                                name={"hide_showoptions_" + item.optionid}
                                onClick={props.manageSearch}
                                className="btn btn-sm searcher-mobile-button"
                              >
                                {getDefValues().hideLabel}
                              </button>
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        ""
                      )}
                      {item.selectedoptions.length > 0 && !item.listoptions ? (
                        <>
                          <ul key={"ul2b" + i} className="categories">
                            {item.options.map((option, i) =>
                              item.selectedoptions.indexOf("" + option.value) >=
                              0 ? (
                                <li key={"li2b" + i} className="active">
                                  <button
                                    key={"button6c" + i}
                                    name={
                                      "filter_options_" +
                                      item.optionid +
                                      "_" +
                                      option.value
                                    }
                                    onClick={props.manageSearch}
                                    className="btn btn-sm name searcher-mobile-button "
                                  >
                                    {option.value}
                                  </button>
                                  <button
                                    key={"button7c" + i}
                                    name={
                                      "filter_options_" +
                                      item.optionid +
                                      "_" +
                                      option.value
                                    }
                                    onClick={props.manageSearch}
                                    className="btn btn-sm quantity "
                                  >
                                    {option.quantity}
                                  </button>
                                </li>
                              ) : (
                                ""
                              ),
                            )}
                          </ul>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  ))
                : ""}
            </div>
          </div>
        </div>
        <div className="row searcher-mobile-results">
          <div className="mobile-col col-md-12 col-lg-12	">
            <InfiniteScroll
              dataLength={cardData.length}
              next={fetchMoreData}
              hasMore={hasMore}
              loader={
                <>
                  <div className="row">
                    {Array.from({
                      length: 2,
                    }).map((_, i) => (
                      <div
                        key={i}
                        className="col-6 col-sm-6 col-md-4 col-lg-2_5 mobile-col d-flex"
                      >
                        <ProductSkeleton />
                      </div>
                    ))}
                  </div>
                </>
              }
              endMessage={""}
            >
              <Card cardData={cardData} cardConfig={cardConfig} />
            </InfiniteScroll>
          </div>
        </div>
      </div>
    </>
  ) : (
    <>
      <PageLoading isLoading={loading === "YES" ? true : false} />
      {props.windowWidth >= 799 ? (
        <div className="">
          <>
            {props.eventId > 0 ? (
              <div className="message-top">
                <div className="event">
                  <span
                    style={{
                      cursor:
                        props.action === "addEventList"
                          ? "pointer"
                          : props.action === "addEventCart"
                            ? "pointer"
                            : "auto",
                    }}
                    target="_top"
                    onClick={() => {
                      if (props.action === "addEventList") {
                        history.push("/customer/event/manage");
                      } else if (props.action === "addEventCart") {
                        history.push("/customer/event/event-details");
                      } else {
                        console.log("no");
                      }
                    }}
                  >
                    {(props.action === "addEventCart"
                      ? getDefValues().eventShopTopMessage
                      : getDefValues().eventTopMessage) +
                      " " +
                      props.eventName}
                    <span style={{ textDecoration: "underline" }}>
                      {" "}
                      {getDefValues().eventShopTopMessage2}{" "}
                    </span>
                  </span>
                </div>

                <button
                  type="button"
                  onClick={() => {
                    setTempStore(0);
                    toggleModal();
                  }}
                  className="close white-text"
                  aria-label="Close"
                >
                  <span aria-hidden="true">x</span>
                </button>
                <Modal
                  content={
                    <>
                      <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 text-center mb-30 mt-30 ">
                          <h4> {getDefValues().gooutOfEventModeMessage} </h4>
                        </div>
                      </div>
                    </>
                  }
                  staticBackdrop={false}
                  toogleCloseButton={true}
                  formAction={setEventMode}
                  btncolor={"secondary"}
                  formButtonLabel={getDefValues().yeslabel}
                  secondaryFormButtonLabel={getDefValues().nolabel}
                  toggleModal={toggleModal}
                  modal={showForm}
                  btncolorbtncolor="secondary"
                />
              </div>
            ) : (
              ""
            )}
            {props.topMessages.map((item, i) => (
              <div
                key={"div5" + i}
                className={
                  (item.hide ? " message-top-hide " : "") + "message-top"
                }
              >
                <div key={"div6" + i} className="" style={item.style}>
                  <a
                    key={"a6" + i}
                    style={item.style}
                    href={item.link}
                    target="_top"
                  >
                    {" "}
                    {item.message}{" "}
                  </a>
                </div>
                {item.style.closable === "NO" ? (
                  ""
                ) : (
                  <button
                    key={"button8" + i}
                    type="button"
                    name={item.name}
                    onClick={props.hideMessage}
                    className="close"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">x</span>
                  </button>
                )}
              </div>
            ))}
          </>
        </div>
      ) : (
        ""
      )}
      <div className={"header-area header-style-1 header-height-2  "}>
        <div className="header-middle header-middle-ptb-1-sm d-none d-lg-block">
          <div className="container header-container">
            <div className="header-wrap">
              <div className="logo logo-width-1">
                <a onClick={props.forceHideCart} href="/">
                  <img src={logo} alt="logo" />
                </a>
              </div>
              <div className="header-right">
                <div className="search-style-2">
                  <div className="row mr-1">
                    {storeid > 0 ? (
                      <>
                        {" "}
                        {props.action === "" && props.showFilters ? (
                          <form action="/search">
                            <input
                              type="text"
                              name="key"
                              ref={(input) =>
                                input && props.mobileFirstTime
                                  ? input.focus()
                                  : ""
                              }
                              value={searchinput}
                              onChange={changeHandlerS}
                              onKeyDown={changeHandlerS}
                              className="search-web"
                              placeholder={getDefValues().searchLabel}
                            />
                          </form>
                        ) : (
                          ""
                        )}
                        {searchinput.length >= 3 && (
                          <div className="search-container-2">
                            <div
                              style={{
                                backgroundColor: "#fff",
                                display: "flex",
                                padding: "10px",
                                flexWrap: "wrap",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  width: "80%",
                                  textAlign: "left",
                                }}
                              >
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                  }}
                                >
                                  {" "}
                                  {(
                                    "Productos para " + searchinput
                                  ).toUpperCase()}{" "}
                                </span>
                              </div>
                              <div
                                style={{
                                  width: "20%",
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <span
                                  onClick={(e) => {
                                    props.forceHideCart();
                                    setSearchinput("");
                                  }}
                                  className="font-md text-bold cursor-pointer"
                                >
                                  Cerrar X
                                </span>
                              </div>
                            </div>
                            <div
                              style={{
                                width: "20%",
                                paddingRight: "5px",
                                borderRight: "1px dotted #ccc",
                              }}
                            >
                              {/*<span style={{fontWeight: "bold", width: "100%"}}>Recomendaciones</span>*/}
                              {/*<br/>*/}

                              <div className="suggest-label mt-2 text-bold">
                                SUGERENCIAS
                              </div>
                            </div>
                            <div
                              style={{
                                width: "80%",
                                display: "flex",
                                flexWrap: "wrap",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  width: "100%",
                                }}
                              >
                                <button
                                  onClick={(e) => {
                                    navigateTo(searchinput);
                                    setSearchinput("");
                                  }}
                                  style={{
                                    height: 20,
                                    textDecoration: "underline",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    width: "100%",
                                    backgroundColor: "#fff",
                                    border: "0px",
                                  }}
                                >
                                  Ver Todos los Resultados
                                </button>
                              </div>

                              <Card
                                cardData={cardData}
                                cardConfig={cardConfig}
                              />
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="header-action-right">
                  <div className="header-action-2">
                    {/*eventIco */}
                    <div
                      className="header-action-icon-2"
                      style={{ width: 28, height: 28, marginRight: 15 }}
                    >
                      <a href="/customer/event/home">
                        <button className="no-button mini-event-icon">
                          <img
                            className="svgInject"
                            alt="event-web"
                            style={{ height: 27, opacity: 0.9 }}
                            src={getImagePath("/catalog/images/event.svg")}
                          />

                          {eventQty > 0 && (
                            <span className="pro-count blue"> {eventQty} </span>
                          )}
                        </button>
                      </a>
                      <div
                        style={{ right: 0, left: 0 }}
                        className="user-info card"
                      >
                        <ul>
                          {eventMenuoptions.map((item, i) =>
                            item.validationValue ? (
                              <>
                                {localStorage.getItem(
                                  process.env.REACT_APP_ORG_NAME +
                                    "_" +
                                    item.validationValue,
                                ) && (
                                  <li key={"li3e" + i}>
                                    {item.link.indexOf(
                                      "/customer/event/manage",
                                    ) >= 0 &&
                                    eventActionM !== "addEventCart" ? (
                                      <a
                                        href={item.link}
                                        key={"sh1_2" + i}
                                        className="link-menu"
                                      >
                                        {item.label}
                                      </a>
                                    ) : (
                                      <a
                                        href="#"
                                        key={"sh1" + i}
                                        onClick={() => {
                                          if (item.link) {
                                            if (item.action) {
                                              if (
                                                item.action ===
                                                "checkEventStatus"
                                              ) {
                                                checkEventStatus(item);
                                              }
                                            } else {
                                              history.push(item.link);
                                            }
                                            props.forceHideCart();
                                          } else {
                                            props.forceHideCart();
                                          }
                                        }}
                                        className="link-menu"
                                      >
                                        {item.label}
                                      </a>
                                    )}
                                  </li>
                                )}
                              </>
                            ) : (
                              <li key={"li3e" + i}>
                                <a
                                  href="#"
                                  key={"sh1" + i}
                                  onClick={() => {
                                    if (item.link) {
                                      if (item.action) {
                                        if (
                                          item.action === "checkEventStatus"
                                        ) {
                                          checkEventStatus(item);
                                        }
                                      } else {
                                        history.push(item.link);
                                      }
                                      props.forceHideCart();
                                    } else {
                                      props.forceHideCart();
                                    }
                                  }}
                                  className="link-menu"
                                >
                                  {item.label}
                                </a>
                              </li>
                            ),
                          )}
                        </ul>
                      </div>
                    </div>
                    {/**/}
                    <div className="header-action-icon-2">
                      <button className="no-button mini-stores-icon">
                        <img
                          className="svgInject"
                          alt="Shipping"
                          style={{ height: 21, opacity: 0.9 }}
                          src={getImagePath("/catalog/images/shipping.svg")}
                        />
                      </button>
                      <div
                        className="shipping-info card"
                        style={{
                          top: 35,
                          position: "absolute",
                          width: 351,
                          right: -117,
                          border: "#fff",
                        }}
                      >
                        <div
                          className="row"
                          style={{
                            border: "1px solid #e6e6e6",
                            borderRadius: 6,
                            marginTop: 4,
                            background: "#fff",
                            marginBottom: 10,
                          }}
                        >
                          {shippingMenuoptions.map((item, i) => (
                            <div
                              key={"div9" + i}
                              className={
                                (item.size ? item.size : " col-12 ") +
                                " " +
                                (item.height ? item.height : " mt-3 ") +
                                " " +
                                (item.align
                                  ? "items-" + item.align + " flex"
                                  : "") +
                                " " +
                                (i === shippingMenuoptions.length - 1 //check!
                                  ? "mb-4"
                                  : "")
                              }
                            >
                              <a key={"sh1" + i} href={item.link}>
                                {item.type === "IMAGE" ? (
                                  <>
                                    <img
                                      key={"img1" + i}
                                      style={{
                                        width: item.width ? item.width : "45px",
                                      }}
                                      name={"manageImage_" + item.PRODUCTNAME}
                                      className=""
                                      src={
                                        item.image !== ""
                                          ? item.image
                                          : defaultImage
                                      }
                                    />
                                    <div key={"div9a" + i} className="mt-3">
                                      {" "}
                                      {item.label}{" "}
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}
                                {item.type === "BUTTON" ? (
                                  <div
                                    key={"div9b" + i}
                                    className="btn btn-primary"
                                  >
                                    {" "}
                                    {item.label}{" "}
                                  </div>
                                ) : (
                                  ""
                                )}
                                {item.type === "TEXT" ? (
                                  <span key={"span9a" + i}> {item.label} </span>
                                ) : (
                                  ""
                                )}
                              </a>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="header-action-icon-2">
                      <a href={"/pages/tiendas"} className="mini-store-icon">
                        <img
                          className="svgInject"
                          style={{ height: 21, opacity: 0.9 }}
                          alt="ci"
                          src={getImagePath("/catalog/images/stores.svg")}
                        />
                      </a>
                    </div>

                    <div className="header-action-icon-2">
                      <Link to="/customer/account">
                        <span className="mini-user-icon">
                          <img
                            className="svgInject"
                            style={{ height: 21, opacity: 0.9 }}
                            alt="ci"
                            src={getImagePath("/catalog/images/user.svg")}
                          />
                        </span>
                      </Link>
                      <div className="user-info card">
                        <ul>
                          {loginInfo.userId != null ? (
                            <>
                              {loggedMenuoptions.map((item, i) => (
                                <li key={"li3" + i}>
                                  <a
                                    key={"info1" + i}
                                    href={item.link}
                                    className={i === 0 ? "text-bold" : ""}
                                  >
                                    {item.label +
                                      (i === 0
                                        ? " " + loginInfo.token.firstname
                                        : "")}
                                  </a>
                                </li>
                              ))}
                            </>
                          ) : (
                            <>
                              {loginMenuoptions.map((item, i) => (
                                <li key={"li3b" + i}>
                                  <a key={"info2" + i} href={item.link}>
                                    {item.label}
                                  </a>
                                </li>
                              ))}
                            </>
                          )}
                        </ul>
                      </div>
                    </div>

                    <div className="header-action-icon-2 mt-2">
                      {" "}
                      {/*WEB*/}
                      {props.action !== "addEventList" && (
                        <button
                          onClick={props.toggleCart}
                          className="no-button mini-cart-icon"
                        >
                          <img
                            className="svgInject"
                            alt="Shop Cart"
                            style={{ height: 22, opacity: 0.9 }}
                            src={getImagePath("/catalog/images/shopcart.svg")}
                          />

                          {shopCart?.products ? (
                            <>
                              {shopCart.products.length > 0 ? (
                                <span
                                  className={
                                    "pro-count blue" +
                                    (props.action === "addEventCart"
                                      ? " event-pro-count"
                                      : "")
                                  }
                                >
                                  {" "}
                                  {totalProd}{" "}
                                </span>
                              ) : (
                                ""
                              )}
                            </>
                          ) : (
                            ""
                          )}
                        </button>
                      )}
                      <div
                        className={
                          props.showCart ? "showCart-active" : "showCart"
                        }
                      >
                        {shopCart?.products ? (
                          <>
                            {shopCart.products.length === 0 ? (
                              <div className="card">
                                <div className="card-body">
                                  <div className="row text-08 mt-30 mb-3 ml-2">
                                    <div className="col-12 flex items-center">
                                      <b>{getDefValues().noProductsOnCart} </b>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="card">
                                <div className="card-body mini-cart">
                                  <div className="row text-08 mt-3 ml-2">
                                    <div className="col-8 flex items-left text-bold">
                                      {totalProd} {getDefValues().productsLabel}
                                    </div>

                                    <div className="col-4 text-right">
                                      {getDefValues().shopCartSubtotalLabel}
                                      <p className="text-bold text-price">
                                        {" "}
                                        {getCurrency()}
                                        {toFixed(shopCart.total)}{" "}
                                      </p>
                                    </div>
                                  </div>

                                  {shopCart?.products.map((item, i) => (
                                    <div key={"div10" + i} className="row mt-2">
                                      <div
                                        key={"div10" + i}
                                        className="col-4 flex items-left"
                                      >
                                        <a
                                          key={"a2" + i}
                                          href={
                                            (item.category
                                              ? "/" + item.category + "/"
                                              : "/productDetails/") +
                                            (item.productpath
                                              ? item.productpath
                                              : item.productname)
                                          }
                                        >
                                          <img
                                            key={"img2" + i}
                                            alt={item.productname}
                                            src={getImagePath(item.image)}
                                            className="card-img-top"
                                          />
                                        </a>
                                      </div>
                                      <div
                                        key={"div10b" + i}
                                        className="col-6  text-left middle"
                                      >
                                        <a
                                          key={"a2b" + i}
                                          onClick={props.forceHideCart}
                                          href={
                                            (item.category
                                              ? "/" + item.category + "/"
                                              : "/productDetails/") +
                                            (item.productpath
                                              ? item.productpath
                                              : item.productname)
                                          }
                                        >
                                          {item.productname}
                                        </a>

                                        {!item.optionsselected ? (
                                          ""
                                        ) : item.optionsselected.length > 0 ? (
                                          <ul key={"ul10" + i} className="mt-1">
                                            {item.optionsselected.map(
                                              (op, i) => (
                                                <li
                                                  key={"li10" + i}
                                                  className=""
                                                >
                                                  <>
                                                    {op.optionLabel ? (
                                                      op.optionLabel + ": "
                                                    ) : (
                                                      <>
                                                        {props.options.map(
                                                          (ol) =>
                                                            Number(
                                                              ol.OPTIONID,
                                                            ) ===
                                                            Number(op.optionid)
                                                              ? ol.OPTIONNAME +
                                                                ": "
                                                              : "",
                                                        )}
                                                      </>
                                                    )}
                                                    <span
                                                      key={"span10" + i}
                                                      className="text-bold"
                                                    >
                                                      {op.optionvalue}
                                                    </span>
                                                  </>
                                                </li>
                                              ),
                                            )}
                                          </ul>
                                        ) : (
                                          ""
                                        )}
                                        <div key={"div11" + i} className="mb-2">
                                          {item.NEWPRICED ? (
                                            <>
                                              <span
                                                key={"span11" + i}
                                                className="product-price-new-mini"
                                              >
                                                {getCurrency() +
                                                  " " +
                                                  toFixed(item.NEWPRICED)}
                                              </span>
                                              <span
                                                key={"span11b" + i}
                                                className="product-price-old-mini"
                                              >
                                                {" " +
                                                  getCurrency() +
                                                  " " +
                                                  toFixed(item.price)}
                                              </span>
                                            </>
                                          ) : (
                                            <>
                                              {item.NEWPRICEC1 ? (
                                                <>
                                                  <b
                                                    key={"b11" + i}
                                                    className="text-price"
                                                  >
                                                    {getCurrency() +
                                                      " " +
                                                      toFixed(item.price) +
                                                      " "}
                                                  </b>
                                                  <span
                                                    key={"span11c" + i}
                                                    style={{ fontSize: "14px" }}
                                                    className="discount-span"
                                                  >
                                                    {item.priceOld}
                                                  </span>
                                                </>
                                              ) : (
                                                <b
                                                  key={"b11b" + i}
                                                  className="text-price"
                                                >
                                                  {getCurrency() +
                                                    toFixed(item.price)}
                                                </b>
                                              )}
                                            </>
                                          )}
                                        </div>
                                        <input
                                          type="text"
                                          key={"input11" + i}
                                          className="mini-qty-val"
                                          name={"quantity_" + item.productsku}
                                          value={
                                            item.prequantity != null
                                              ? item.prequantity
                                              : item.quantity
                                          }
                                          onChange={props.updateCart}
                                        />

                                        {item.showUpdate ? (
                                          <button
                                            key={"button11" + i}
                                            name={"update_" + item.productsku}
                                            onClick={props.updateCart}
                                            className="confirm-upd-mini"
                                          >
                                            {/*<i className="fas fa-sync-alt"></i>*/}
                                            Actualizar
                                          </button>
                                        ) : (
                                          ""
                                        )}
                                      </div>

                                      <div
                                        key={"div11d" + i}
                                        className="col-1 flex  middle ml-2"
                                      >
                                        <button
                                          key={"button11b" + i}
                                          name={"del_" + item.productsku}
                                          onClick={props.updateCart}
                                          className="icon-trash-mini text-muted ml-1"
                                        >
                                          <img
                                            src={getImagePath(
                                              "/catalog/images/ico_trash.svg",
                                            )}
                                            alt="delete-product-web"
                                            width="20px"
                                            height="20px"
                                          />
                                        </button>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                                <div className="card-footer">
                                  <div className="row">
                                    <div className="col-12 flex items-center">
                                      <button
                                        onClick={() => {
                                          history.push("/checkout/cart", {
                                            step: "formstep1",
                                          });
                                          props.toggleCart();
                                        }}
                                        className="btn btn-sm btn-primary mr-2"
                                      >
                                        {" "}
                                        {/*web*/}
                                        {getDefValues().completeOrder.toUpperCase()}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {props.windowWidth < 799 ? (
          <div className="">
            <>
              {props.eventId > 0 ? (
                <div className="message-top">
                  <div className="event">
                    <span
                      style={{
                        cursor:
                          props.action === "addEventList"
                            ? "pointer"
                            : props.action === "addEventCart"
                              ? "pointer"
                              : "auto",
                      }}
                      target="_top"
                      onClick={() => {
                        if (props.action === "addEventList") {
                          history.push("/customer/event/manage");
                        } else if (props.action === "addEventCart") {
                          history.push("/customer/event/event-details");
                        } else {
                          console.log("no");
                        }
                      }}
                    >
                      {(props.action === "addEventCart"
                        ? getDefValues().eventShopTopMessage
                        : getDefValues().eventTopMessage) +
                        " " +
                        props.eventName}
                      <span style={{ textDecoration: "underline" }}>
                        {" "}
                        {getDefValues().eventShopTopMessage2}{" "}
                      </span>
                    </span>

                    <button
                      type="button"
                      onClick={() => {
                        setTempStore(0);
                        toggleModal();
                      }}
                      className="close white-text"
                      aria-label="Close"
                    >
                      <span style={{ paddingRight: 5 }} aria-hidden="true">
                        x
                      </span>
                    </button>
                  </div>

                  <Modal
                    content={
                      <>
                        <div className="row">
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12 text-center mb-30 mt-30 ">
                            <h4> {getDefValues().gooutOfEventModeMessage} </h4>
                          </div>
                        </div>
                      </>
                    }
                    staticBackdrop={false}
                    toogleCloseButton={true}
                    formAction={setEventMode}
                    btncolor={"secondary"}
                    formButtonLabel={getDefValues().yeslabel}
                    secondaryFormButtonLabel={getDefValues().nolabel}
                    toggleModal={toggleModal}
                    modal={showForm}
                    btncolorbtncolor="secondary"
                  />
                </div>
              ) : (
                ""
              )}

              {props.topMessages.map((item, i) => (
                <div
                  key={"div12" + i}
                  className={
                    (item.hide ? " message-top-hide " : "") + "message-top"
                  }
                >
                  <div key={"div12b" + i} className=" " style={item.style}>
                    <a
                      key={"a12" + i}
                      style={item.style}
                      href={item.link}
                      target="_top"
                    >
                      {" "}
                      {item.message}{" "}
                    </a>
                    {item.style.closable === "NO" ? (
                      ""
                    ) : (
                      <button
                        key={"button12" + i}
                        type="button"
                        name={item.name}
                        onClick={props.hideMessage}
                        className="close"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">x</span>
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </>
          </div>
        ) : (
          ""
        )}
        <div className="container main-store-location flex">
          <div
            className={
              "store-loc-wrap" + (storeMenuOpen ? " store-loc-wrap--open" : "")
            }
          >
            <button
              className="store-loc-trigger"
              onClick={(e) => {
                e.stopPropagation();
                setStoreMenuOpen(!storeMenuOpen);
              }}
            >
              <i className="fas fa-map-marker-alt store-loc-icon" />
              <span className="store-loc-name">
                {props.storesInfo.stores.find(
                  (st) =>
                    Number(st.storeId) ===
                    Number(props.storesInfo.selectedStoreId),
                )?.storeName || ""}
              </span>
              <i className="fas fa-chevron-down store-loc-arrow" />
            </button>
            <div
              className="store-loc-menu"
              onClick={(e) => e.stopPropagation()}
            >
              {props.storesInfo.stores
                .filter((st) => st.visible_popup !== false)
                .filter(
                  (st) =>
                    Number(st.storeId) !==
                    Number(props.storesInfo.selectedStoreId),
                )
                .map((st) => (
                  <button
                    key={st.storeId}
                    className="store-loc-item"
                    onClick={() => {
                      setStoreMenuOpen(false);
                      if (props.eventId > 0) {
                        setTempStore(st.storeId);
                        toggleModal();
                      } else {
                        props.setStore({ target: { name: st.storeId } });
                      }
                    }}
                  >
                    {st.storeName}
                  </button>
                ))}
            </div>
          </div>
        </div>
        {/*
                    <div className={props.scroll
                        ? "header-bottom header-bottom-bg-color sticky-bar stick"
                      : "header-bottom header-bottom-bg-color sticky-bar"}> */}
        <div className="header-bottom header-bottom-bg-color sticky-bar">
          <div className="container header-container">
            <div className="header-wrap header-space-between position-relative">
              <div className="header-action-icon-2 d-block d-lg-none">
                <div
                  className="burger-icon burger-icon-white"
                  onClick={props.toggleClick}
                >
                  <span className="burger-icon-top"></span>
                  <span className="burger-icon-mid"></span>
                  <span className="burger-icon-bottom"></span>
                </div>
              </div>

              <div className="logo logo-width-1 d-block d-lg-none">
                <a href="/">
                  <img src={logo} alt="logo" />
                </a>
              </div>

              <div className="header-nav d-none d-lg-flex">
                <div className="main-menu main-menu-padding-1 main-menu-lh-2 d-none d-lg-block">
                  <nav className="main-menu-navigator">
                    <ul>
                      {/*level 1*/}
                      {menu.map((l1) =>
                        String(l1.MENULEVEL) === "1" ? (
                          <li
                            className={
                              l1.ADITIONALCONFIG.configmenu2 === "YES"
                                ? "position-static"
                                : ""
                            }
                          >
                            <a
                              style={{
                                background: l1.ADITIONALCONFIG.configbackground
                                  ? l1.ADITIONALCONFIG.configbackground
                                  : "#fff",
                                color: l1.ADITIONALCONFIG.configcolor
                                  ? l1.ADITIONALCONFIG.configcolor
                                  : "#696158",
                              }}
                              href={l1.MENUURL ? l1.MENUURL : "#"}
                            >
                              {l1.MENULABEL}{" "}
                              <i className="fi-rs-angle-down"></i>
                            </a>
                            {/*level 2*/}
                            {l1.ISPARENT ? (
                              <>
                                {l1.ADITIONALCONFIG.configmenu2 === "YES" &&
                                l1.MENUTOTALROWS > 1 ? (
                                  <ul className="mega-menu">
                                    {l1.MENUROWS.map((row) => (
                                      <li
                                        className={
                                          "sub-mega-menu " + l1.MENUWIDTHCLASS
                                        }
                                      >
                                        <ul>
                                          {l1.MENUCHILDS.map((l2) =>
                                            l2.row === row ? (
                                              <li>
                                                <a
                                                  href={
                                                    l2.MENUURL
                                                      ? l2.MENUURL
                                                      : "#"
                                                  }
                                                >
                                                  <span>{l2.MENULABEL}</span>
                                                </a>
                                              </li>
                                            ) : (
                                              ""
                                            ),
                                          )}
                                        </ul>
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <ul className="sub-menu">
                                    {menu.map((l2) =>
                                      String(l2.MENULEVEL) === "2" &&
                                      Number(l1.MENUID) ===
                                        Number(l2.PARENTMENUID) ? (
                                        <li>
                                          <a
                                            href={l2.MENUURL ? l2.MENUURL : "#"}
                                          >
                                            <span>
                                              {l2.PARENTMENUID === 6 &&
                                              l2.configimage !== "" ? (
                                                <img
                                                  src={getImagePath(
                                                    l2.configimage,
                                                  )}
                                                  alt={l2.MENULABEL}
                                                />
                                              ) : (
                                                ""
                                              )}
                                              {l2.MENULABEL}
                                            </span>
                                          </a>
                                          {/*level 3*/}
                                          {l2.ISPARENT ? (
                                            <ul className="level-menu1 level-menu-modify">
                                              {menu.map((l3) =>
                                                Number(l3.MENULEVEL) === 3 &&
                                                Number(l2.MENUID) ===
                                                  Number(l3.PARENTMENUID) ? (
                                                  <li>
                                                    <a
                                                      href={
                                                        l3.MENUURL
                                                          ? l3.MENUURL
                                                          : "#"
                                                      }
                                                    >
                                                      <span>
                                                        {l3.MENULABEL}
                                                      </span>
                                                    </a>
                                                    {/*level 4*/}
                                                    {l3.ISPARENT ? (
                                                      <ul className="level-menu2 level-menu-modify">
                                                        {menu.map((l4) =>
                                                          Number(
                                                            l4.MENULEVEL,
                                                          ) === 4 &&
                                                          Number(l3.MENUID) ===
                                                            Number(
                                                              l4.PARENTMENUID,
                                                            ) ? (
                                                            <li>
                                                              <a
                                                                href={
                                                                  l4.MENUURL
                                                                    ? l4.MENUURL
                                                                    : "#"
                                                                }
                                                              >
                                                                {l4.MENULABEL}
                                                              </a>
                                                            </li>
                                                          ) : (
                                                            ""
                                                          ),
                                                        )}
                                                      </ul>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </li>
                                                ) : (
                                                  ""
                                                ),
                                              )}
                                            </ul>
                                          ) : (
                                            ""
                                          )}
                                        </li>
                                      ) : (
                                        ""
                                      ),
                                    )}
                                  </ul>
                                )}
                              </>
                            ) : (
                              ""
                            )}
                          </li>
                        ) : (
                          ""
                        ),
                      )}
                    </ul>
                  </nav>
                </div>
              </div>

              <div className="header-action-right d-block d-lg-none">
                <div className="header-action-2">
                  <div className="header-action-icon-2">
                    {/*eventIco */}
                    <a
                      href="#"
                      onClick={props.toggleEventInfo}
                      className="mini-event-icon"
                    >
                      <img
                        className="svgInject"
                        style={{ height: 26, opacity: 0.9 }}
                        src={getImagePath("/catalog/images/event.svg")}
                      />

                      {eventQty > 0 && (
                        <span className="pro-count event-pro-count">
                          {" "}
                          {eventQty}{" "}
                        </span>
                      )}
                    </a>

                    <div
                      className={
                        "user-info card" + (props.showEventInfo ? " show " : "")
                      }
                    >
                      <ul>
                        {eventMenuoptions.map((item, i) =>
                          item.validationValue ? (
                            <>
                              {localStorage.getItem(
                                process.env.REACT_APP_ORG_NAME +
                                  "_" +
                                  item.validationValue,
                              ) && (
                                <li key={"li3e" + i}>
                                  {item.link.indexOf(
                                    "/customer/event/manage",
                                  ) >= 0 && eventActionM !== "addEventCart" ? (
                                    <a
                                      href={item.link}
                                      key={"sh1_3" + i}
                                      className="link-menu"
                                    >
                                      {item.label}
                                    </a>
                                  ) : (
                                    <a
                                      href="#"
                                      key={"sh1" + i}
                                      onClick={() => {
                                        if (item.link) {
                                          if (item.action) {
                                            if (
                                              item.action === "checkEventStatus"
                                            ) {
                                              checkEventStatus(item);
                                            }
                                          } else {
                                            history.push(item.link);
                                          }
                                          props.forceHideEventIco();
                                          props.forceHideCart();
                                        } else {
                                          props.forceHideEventIco();
                                          props.forceHideCart();
                                        }
                                      }}
                                      className="link-menu"
                                    >
                                      {item.label}
                                    </a>
                                  )}
                                </li>
                              )}
                            </>
                          ) : (
                            <li key={"li3e" + i}>
                              <a
                                href="#"
                                key={"sh1" + i}
                                onClick={() => {
                                  if (item.link) {
                                    if (item.action) {
                                      if (item.action === "checkEventStatus") {
                                        checkEventStatus(item);
                                      }
                                    } else {
                                      history.push(item.link);
                                    }
                                    props.forceHideCart();
                                    props.forceHideEventIco();
                                  } else {
                                    props.forceHideCart();
                                    props.forceHideEventIco();
                                  }
                                }}
                                className="link-menu"
                              >
                                {item.label}
                              </a>
                            </li>
                          ),
                        )}
                      </ul>
                    </div>

                    {/*mob*/}
                  </div>

                  <div className="header-action-icon-2">
                    <a
                      href="#"
                      onClick={props.toggleUserInfo}
                      className="mini-user-icon"
                    >
                      <img
                        className="svgInject"
                        style={{ height: 21, opacity: 0.8 }}
                        alt="ci"
                        src={getImagePath("/catalog/images/user.svg")}
                      />
                    </a>

                    <div
                      className={
                        "user-info card" + (props.showUserInfo ? " show " : "")
                      }
                    >
                      <ul>
                        {loginInfo.userId != null ? (
                          <>
                            {loggedMenuoptions.map((item, i) => (
                              <li>
                                <a
                                  key={"info" + i}
                                  href={item.link}
                                  className={i === 0 ? "text-bold" : ""}
                                >
                                  {item.label +
                                    (i === 0
                                      ? " " + loginInfo.token.firstname
                                      : "")}
                                </a>
                              </li>
                            ))}
                          </>
                        ) : (
                          <>
                            {loginMenuoptions.map((item, i) => (
                              <li>
                                <a key={"info" + i} href={item.link}>
                                  {item.label}
                                </a>
                              </li>
                            ))}
                          </>
                        )}
                      </ul>
                    </div>
                  </div>

                  <div className="header-action-icon-2 ml--2">
                    {props.action !== "addEventList" && (
                      <a
                        href="#"
                        onClick={props.toggleCart}
                        className="mini-cart-icon"
                      >
                        <img
                          className="svgInject"
                          alt="Shop Cart"
                          style={{ height: 21, opacity: 0.8 }}
                          src={getImagePath("/catalog/images/shopcart.svg")}
                        />
                        {shopCart?.products ? (
                          <>
                            {shopCart.products.length > 0 ? (
                              <span
                                className={
                                  "pro-count blue" +
                                  (props.action === "addEventCart"
                                    ? " event-pro-count"
                                    : "")
                                }
                              >
                                {" "}
                                {totalProd}{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          ""
                        )}
                      </a>
                    )}
                    <div
                      className={
                        props.showCart
                          ? "mobile-showCart visible"
                          : "mobile-showCart"
                      }
                    >
                      {shopCart?.products ? (
                        <>
                          {shopCart.products.length === 0 ? (
                            <div className="card">
                              <div className="card-header">
                                <div className="row ">
                                  <div className="col-10 flex items-left">
                                    <span className="h5-responsive">
                                      {getDefValues().cartLabel}
                                    </span>
                                  </div>
                                  <div className="col-2 flex items-right">
                                    <button
                                      type="button"
                                      name="close"
                                      onClick={props.forceHideCart}
                                      className="close"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">x</span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="card-body">
                                <div className="row text-08 mt-30 mb-3 ml-2">
                                  <div className="col-12 flex items-center">
                                    <b>{getDefValues().noProductsOnCart} </b>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="card">
                              <div className="card-header">
                                <div className="row ">
                                  <div className="col-10 flex text-left items-left">
                                    <span className="h5-responsive">
                                      {getDefValues().cartLabel}
                                    </span>
                                  </div>
                                  <div className="col-2 flex text-right items-right">
                                    <button
                                      type="button"
                                      name="close"
                                      onClick={props.forceHideCart}
                                      className="close"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">x</span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="card-body mini-cart">
                                <div className="row text-08 mt-3 ml-2">
                                  <div className="col-8 flex items-left">
                                    {totalProd} {getDefValues().productsLabel}
                                  </div>

                                  <div className="col-4 text-right">
                                    {getDefValues().shopCartSubtotalLabel}
                                    <p className="text-bold text-price">
                                      {" "}
                                      {getCurrency()}
                                      {toFixed(shopCart.total)}{" "}
                                    </p>
                                  </div>
                                </div>

                                {shopCart?.products.map((item) => (
                                  <div className="row mt-2">
                                    <div className="col-4 flex items-left">
                                      <a
                                        href={
                                          (item.category
                                            ? "/" + item.category + "/"
                                            : "/productDetails/") +
                                          (item.productpath
                                            ? item.productpath
                                            : item.productname)
                                        }
                                      >
                                        <img
                                          alt={item.productname}
                                          src={getImagePath(item.image)}
                                          className="card-img-top"
                                        />
                                      </a>
                                    </div>
                                    <div className="col-6 text-left middle">
                                      <a
                                        href={
                                          (item.category
                                            ? "/" + item.category + "/"
                                            : "/productDetails/") +
                                          (item.productpath
                                            ? item.productpath
                                            : item.productname)
                                        }
                                      >
                                        {item.productname}
                                      </a>

                                      {!item.optionsselected ? (
                                        ""
                                      ) : item.optionsselected.length > 1 ? (
                                        <ul className="mt-1">
                                          {item.optionsselected.map((op) => (
                                            <li className="">
                                              <>
                                                {op.optionLabel ? (
                                                  op.optionLabel + ": "
                                                ) : (
                                                  <>
                                                    {props.options.map((ol) =>
                                                      Number(ol.OPTIONID) ===
                                                      Number(op.optionid)
                                                        ? ol.OPTIONNAME + ": "
                                                        : "",
                                                    )}
                                                  </>
                                                )}
                                                <span className="text-bold">
                                                  {op.optionvalue}
                                                </span>
                                              </>
                                            </li>
                                          ))}
                                        </ul>
                                      ) : (
                                        ""
                                      )}
                                      <div className="mb-2">
                                        {item.NEWPRICED ? (
                                          <>
                                            <span className="product-price-new-mini">
                                              {getCurrency() +
                                                " " +
                                                toFixed(item.NEWPRICED)}
                                            </span>
                                            <span className="product-price-old-mini">
                                              {" " +
                                                getCurrency() +
                                                " " +
                                                toFixed(item.price)}
                                            </span>
                                          </>
                                        ) : (
                                          <>
                                            {item.NEWPRICEC1 ? (
                                              <>
                                                <b className="text-price">
                                                  {getCurrency() +
                                                    " " +
                                                    toFixed(item.price) +
                                                    " "}
                                                </b>
                                                <span
                                                  style={{ fontSize: "14px" }}
                                                  className="discount-span"
                                                >
                                                  {item.priceOld}
                                                </span>
                                              </>
                                            ) : (
                                              <b className="text-price">
                                                {getCurrency() +
                                                  toFixed(item.price)}
                                              </b>
                                            )}
                                          </>
                                        )}
                                      </div>
                                      <input
                                        type="text"
                                        className="mini-qty-val"
                                        name={"quantity_" + item.productsku}
                                        value={
                                          item.prequantity != null
                                            ? item.prequantity
                                            : item.quantity
                                        }
                                        onChange={props.updateCart}
                                      />
                                      {item.showUpdate ? (
                                        <button
                                          name={"update_" + item.productsku}
                                          onClick={props.updateCart}
                                          className="confirm-upd-mini"
                                        >
                                          {/*<i className="fas fa-sync-alt"></i>*/}
                                          Actualizar
                                        </button>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    <div className="col-2 flex items-left middle">
                                      <button
                                        name={"del_" + item.productsku}
                                        onClick={props.updateCart}
                                        className="icon-trash-mini text-muted ml-1"
                                      >
                                        <img
                                          src={getImagePath(
                                            "/catalog/images/ico_trash.svg",
                                          )}
                                          alt="delete-product-mobile"
                                          width="20px"
                                          height="20px"
                                        />
                                      </button>
                                    </div>
                                  </div>
                                ))}
                              </div>
                              <div className="card-footer">
                                <div className="row">
                                  <div className="col-12 flex items-center">
                                    {/*mob*/}
                                    <button
                                      onClick={() => {
                                        history.push("/checkout/cart", {
                                          step: "formstep1",
                                        });
                                        props.toggleCart();
                                        props.forceHideCart();
                                      }}
                                      className="btn btn-sm btn-primary mr-2"
                                    >
                                      {getDefValues().completeOrder.toUpperCase()}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div
                    className={
                      props.isToggled
                        ? "mobile-header-active mobile-header-wrapper-style sidebar-visible"
                        : "mobile-header-active mobile-header-wrapper-style"
                    }
                  >
                    <div className="mobile-header-wrapper-inner">
                      <div className="mobile-header-top">
                        <div className="mobile-header-logo">
                          <Link to="/">
                            <span>
                              <img src={logo} alt="logo" />
                            </span>
                          </Link>
                        </div>
                        <div className="mobile-menu-close close-style-wrap close-style-position-inherit">
                          <button
                            className="close-style search-close"
                            onClick={props.toggleClick}
                          >
                            <i className="icon-top"></i>
                            <i className="icon-bottom"></i>
                          </button>
                        </div>
                      </div>
                      <div className="mobile-header-content-area">
                        <div className="mobile-social-menu">
                          <nav>
                            <ul className="mobile-menu">
                              {mobileMenuoptions.map((item, i) =>
                                item.type === "TOP" ? (
                                  (item.needlogin === "YES" &&
                                    loginInfo.userId != null) ||
                                  item.needlogin === "NO" ? (
                                    <li>
                                      <a
                                        onClick={props.toggleClick}
                                        href={item.link}
                                      >
                                        {item.image ? (
                                          <img
                                            src={getImagePath(item.image)}
                                            alt="logo"
                                          />
                                        ) : (
                                          ""
                                        )}
                                        {item.label}
                                      </a>
                                    </li>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  ""
                                ),
                              )}
                              {menu.map((l1) =>
                                Number(l1.MENULEVEL) === 1 ? (
                                  <li className="category-mobile-menu">
                                    <div
                                      name={l1.MENUID}
                                      onClick={
                                        l1.ISPARENT
                                          ? props.toggleMenuTemplate
                                          : props.emtpyFunction
                                      }
                                    >
                                      <a
                                        name={l1.MENUID}
                                        href={
                                          l1.MENUURL
                                            ? l1.ISPARENT
                                              ? "#"
                                              : l1.MENUURL
                                            : "#"
                                        }
                                      >
                                        <span
                                          className={l1.OPEN && "text-bold"}
                                        >
                                          {l1.MENULABEL}
                                        </span>
                                      </a>
                                      {l1.ISPARENT ? (
                                        <i
                                          name={l1.MENUID}
                                          className={
                                            "fi-rs-angle-" +
                                            (l1.OPEN ? "up" : "down")
                                          }
                                        ></i>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    {/*level 2*/}
                                    {l1.ISPARENT && l1.OPEN && (
                                      <ul className="subcategory-mobile-menu2">
                                        {l1.MENUURL && l1.MENUURL !== "#" ? (
                                          <li>
                                            <div name={l1.MENUID}>
                                              <a
                                                name={l1.MENUID}
                                                href={l1.MENUURL}
                                              >
                                                <span>
                                                  {" "}
                                                  {getDefValues().allLabel +
                                                    " " +
                                                    l1.MENULABEL}{" "}
                                                </span>
                                              </a>
                                            </div>
                                          </li>
                                        ) : (
                                          ""
                                        )}
                                        {menu.map((l2) =>
                                          Number(l2.MENULEVEL) === 2 &&
                                          Number(l1.MENUID) ===
                                            Number(l2.PARENTMENUID) ? (
                                            <li>
                                              <div
                                                name={l2.MENUID}
                                                onClick={
                                                  l2.ISPARENT
                                                    ? props.toggleMenuTemplate
                                                    : props.emtpyFunction
                                                }
                                              >
                                                <a
                                                  name={l2.MENUID}
                                                  href={
                                                    l2.MENUURL
                                                      ? l2.ISPARENT
                                                        ? "#"
                                                        : l2.MENUURL
                                                      : "#"
                                                  }
                                                >
                                                  {Number(l2.PARENTMENUID) ===
                                                    6 &&
                                                  l2.configimage !== "" ? (
                                                    <div>
                                                      <img
                                                        src={getImagePath(
                                                          l2.configimage,
                                                        )}
                                                        alt={l2.MENULABEL}
                                                      />
                                                    </div>
                                                  ) : (
                                                    ""
                                                  )}

                                                  <span
                                                    className={
                                                      l2.OPEN && "text-bold"
                                                    }
                                                  >
                                                    {l2.MENULABEL}
                                                  </span>
                                                </a>
                                                {l2.ISPARENT ? (
                                                  <i
                                                    name={l2.MENUID}
                                                    className={
                                                      "fi-rs-angle-" +
                                                      (l2.OPEN ? "up" : "down")
                                                    }
                                                  ></i>
                                                ) : (
                                                  ""
                                                )}
                                              </div>
                                              {/*level 3*/}
                                              {l2.ISPARENT && l2.OPEN && (
                                                <ul className="subcategory-mobile-menu3">
                                                  {l2.MENUURL &&
                                                  l2.MENUURL !== "#" ? (
                                                    <li>
                                                      <div name={l2.MENUID}>
                                                        <a
                                                          name={l2.MENUID}
                                                          href={l2.MENUURL}
                                                        >
                                                          <span>
                                                            {" "}
                                                            {getDefValues()
                                                              .allLabel +
                                                              " " +
                                                              l2.MENULABEL}{" "}
                                                          </span>
                                                        </a>
                                                      </div>
                                                    </li>
                                                  ) : (
                                                    ""
                                                  )}
                                                  {menu.map((l3) =>
                                                    String(l3.MENULEVEL) ===
                                                      "3" &&
                                                    String(l2.MENUID) ===
                                                      String(
                                                        l3.PARENTMENUID,
                                                      ) ? (
                                                      <li name={l3.MENUID}>
                                                        <div
                                                          onClick={
                                                            l3.ISPARENT
                                                              ? props.toggleMenuTemplate
                                                              : props.emtpyFunction
                                                          }
                                                          name={l3.MENUID}
                                                        >
                                                          <a
                                                            href={
                                                              l3.MENUURL
                                                                ? l3.ISPARENT
                                                                  ? "#"
                                                                  : l3.MENUURL
                                                                : "#"
                                                            }
                                                          >
                                                            <span
                                                              className={
                                                                l3.OPEN &&
                                                                "text-bold"
                                                              }
                                                            >
                                                              {l3.MENULABEL}
                                                            </span>
                                                          </a>
                                                          {l3.ISPARENT ? (
                                                            <i
                                                              name={l3.MENUID}
                                                              className={
                                                                "fi-rs-angle-" +
                                                                (l3.OPEN
                                                                  ? "up"
                                                                  : "down")
                                                              }
                                                            ></i>
                                                          ) : (
                                                            ""
                                                          )}
                                                        </div>
                                                        {/*level 4*/}
                                                        {l3.ISPARENT &&
                                                          l3.OPEN && (
                                                            <ul className="subcategory-mobile-menu4">
                                                              {l3.MENUURL &&
                                                              l3.MENUURL !==
                                                                "#" ? (
                                                                <li>
                                                                  <div
                                                                    name={
                                                                      l3.MENUID
                                                                    }
                                                                  >
                                                                    <a
                                                                      name={
                                                                        l3.MENUID
                                                                      }
                                                                      href={
                                                                        l3.MENUURL
                                                                      }
                                                                    >
                                                                      <span>
                                                                        {" "}
                                                                        {getDefValues()
                                                                          .allLabel +
                                                                          " " +
                                                                          l3.MENULABEL}{" "}
                                                                      </span>
                                                                    </a>
                                                                  </div>
                                                                </li>
                                                              ) : (
                                                                ""
                                                              )}
                                                              {menu.map((l4) =>
                                                                Number(
                                                                  l4.MENULEVEL,
                                                                ) === 4 &&
                                                                Number(
                                                                  l3.MENUID,
                                                                ) ===
                                                                  Number(
                                                                    l4.PARENTMENUID,
                                                                  ) ? (
                                                                  <li
                                                                    name={
                                                                      l4.MENUID
                                                                    }
                                                                  >
                                                                    <div
                                                                      name={
                                                                        l4.MENUID
                                                                      }
                                                                    >
                                                                      <a
                                                                        href={
                                                                          l4.MENUURL
                                                                            ? l4.MENUURL
                                                                            : "#"
                                                                        }
                                                                      >
                                                                        <span
                                                                          className={
                                                                            l4.OPEN &&
                                                                            "text-bold"
                                                                          }
                                                                        >
                                                                          {
                                                                            l4.MENULABEL
                                                                          }
                                                                        </span>
                                                                      </a>
                                                                      {l4.ISPARENT ? (
                                                                        <i
                                                                          onClick={
                                                                            props.toggleMenuTemplate
                                                                          }
                                                                          name={
                                                                            l4.MENUID
                                                                          }
                                                                          className={
                                                                            "fi-rs-angle-" +
                                                                            (l4.OPEN
                                                                              ? "up"
                                                                              : "down")
                                                                          }
                                                                        ></i>
                                                                      ) : (
                                                                        ""
                                                                      )}
                                                                    </div>
                                                                    {/*level 4*/}
                                                                    {l4.ISPARENT &&
                                                                    l4.OPEN ? (
                                                                      <></>
                                                                    ) : (
                                                                      ""
                                                                    )}
                                                                  </li>
                                                                ) : (
                                                                  ""
                                                                ),
                                                              )}
                                                            </ul>
                                                          )}
                                                      </li>
                                                    ) : (
                                                      ""
                                                    ),
                                                  )}
                                                </ul>
                                              )}
                                            </li>
                                          ) : (
                                            ""
                                          ),
                                        )}
                                      </ul>
                                    )}
                                  </li>
                                ) : (
                                  ""
                                ),
                              )}
                              {mobileMenuoptions.map((item, i) =>
                                item.type === "BOTTOM" ? (
                                  (item.needlogin === "YES" &&
                                    loginInfo.userId != null) ||
                                  item.needlogin === "NO" ? (
                                    <li>
                                      <a
                                        onClick={props.toggleClick}
                                        href={item.link}
                                      >
                                        {item.image ? (
                                          <img
                                            src={getImagePath(item.image)}
                                            alt="logo"
                                          />
                                        ) : (
                                          ""
                                        )}
                                        {item.label}
                                      </a>
                                    </li>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  ""
                                ),
                              )}
                            </ul>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {props.action === "" ? (
              <div className="hide-web">
                <div className="search-style-2">
                  <form>
                    <input
                      type="text"
                      name="key"
                      value={props.searchinput}
                      onClick={props.openSearcher}
                      placeholder={getDefValues().searchLabel}
                    />
                  </form>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default Header;
